import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "button", "overlay", "main", "close"]

  connect() {
    this.mobile = window.matchMedia("(max-width: 840px)")
    this.onResize = () => this.close(false)
    this.mobile.addEventListener("change", this.onResize)
  }

  disconnect() {
    this.mobile.removeEventListener("change", this.onResize)
    this.close(false)
  }

  open() {
    if (!this.mobile.matches) return
    this.panelTarget.classList.add("is-open")
    this.panelTarget.setAttribute("role", "dialog")
    this.panelTarget.setAttribute("aria-modal", "true")
    this.buttonTarget.setAttribute("aria-expanded", "true")
    this.overlayTarget.hidden = false
    this.mainTarget.inert = true
    this.element.classList.add("admin-menu-open")
    this.closeTarget.focus()
  }

  close(restoreFocus = true) {
    const wasOpen = this.panelTarget.classList.contains("is-open")
    this.panelTarget.classList.remove("is-open")
    this.panelTarget.removeAttribute("role")
    this.panelTarget.removeAttribute("aria-modal")
    this.buttonTarget.setAttribute("aria-expanded", "false")
    this.overlayTarget.hidden = true
    this.mainTarget.inert = false
    this.element.classList.remove("admin-menu-open")
    if (wasOpen && restoreFocus && this.mobile.matches) this.buttonTarget.focus()
  }

  keydown(event) {
    if (!this.panelTarget.classList.contains("is-open")) return
    if (event.key === "Escape") {
      event.preventDefault()
      this.close()
    } else if (event.key === "Tab") {
      const items = [...this.panelTarget.querySelectorAll('a[href], button:not([disabled])')]
      const first = items[0]
      const last = items[items.length - 1]
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault()
        last.focus()
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault()
        first.focus()
      }
    }
  }
}
